import { defineStore } from 'pinia'

export interface TextMessageTranslatableState {
  show: boolean,
  text: string,
  type: number,
  top: number
}

const initialState = (): TextMessageTranslatableState => ({
  show: false,
  text: '',
  type: 2,
  top: 20
})

export const textMessageTranslatableState = defineStore('textMessageTranslatableState', {
  state: initialState
})
